module.exports = __webpack_public_path__ + "img/ic_warning.5cdd85bc.svg";